export default __webpack_public_path__ + "static/media/open-positions-pop-up-mobile.d1f750bf.jpg";